export default [
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Абоненты',
    },
    children: [
      {
        path: '',
        name: 'customers-list',
        component: () => import('@/views/customers/customers.vue'),
        meta: {},
      },
      {
        path: 'add',
        name: 'customers-add',
        component: () => import('@/views/customers/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'customers-edit',
        props: true,
        component: () => import('@/views/customers/edit.vue'),
        meta: {
          title: 'Изменить',
        },
      },
    ],
  },
]
